const maxWidth = window.innerWidth;
const maxHeight = window.innerHeight;

nextParticle = new NextParticle({
    image: document.getElementById("logo-particle"),
    addTimestamp: true,
    width: maxWidth,
    height: maxHeight,
    initPosition: 'random',
    initDirection: 'random',
    color: "#f55442",
    particleGap: 1,
    gravity: 0.08,
    mouseForce: 100,
});

window.onresize = function () {
    nextParticle.width = maxWidth;
    nextParticle.height = maxHeight;
    nextParticle.start();
};